import styled from 'styled-components';
import play from 'assets/images/playIcon.png';

const Container = styled.div`
  padding-bottom: 2.25em;
  /* background-image: url('https://bigoventees.com/img/banner1.png');
  background-size: cover; */
  display: grid;
  /* background-repeat: no-repeat; */

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

const Wrapper = styled.div`
  width: 100%;

  h2 {
    grid-area: title;
    font-size: 52px;
    margin: 0 auto;
    line-height: 1em;
    @media (max-width: 767.98px) {
      font-size: 28px;
      margin: 25px 0;
    }
  }
  span {
    color: #272742;
    border-bottom: 5px solid #272742;
  }
  @media (min-width: 1024px) {
    h2 {
      text-align: center;
    }
  }
`;
const Img = styled.img`
  max-width: 100%;
  grid-area: image;
  margin: 0 auto;
  background: black;
  padding: 2em;
  border-radius: 22px;
  box-shadow: 0 0 20px 0 rgba(51, 51, 51, 0.25);
  max-height: 250px;
  height: 250px;
  margin: 25px 0;

  @media (min-width: 1024px) {
    width: 500px;
    max-height: none;
    height: auto;
    margin: 0;
  }
`;

const BannerText = styled.div`
  margin: 0 auto;
  text-align: center;
  grid-area: description;
  p {
    font-size: 23px;
    line-height: 22px;
    margin-bottom: 20px;
    margin-top: 0;
    @media (max-width: 767.98px) {
      font-size: 17px;
      font-weight: 700;
    }
  }
`;
const Links = styled.div`
  width: 100%;
  grid-area: button;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    font-size: 15px;
    background-color: #272742;
    color: #fff;
    padding: 14px 16px;
    flex: 1;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    cursor: pointer;
    font-weight: 700;
    border-radius: 50px;
    line-height: unset;
    box-shadow: none;

    &:hover {
      background-color: #272742;
    }

    span {
      color: #fff;
      border: none;
    }

    @media (max-width: 767px) {
      font-size: 13px;
    }
  }

  button:last-child {
    background-color: #ffffff;
    color: #272742;
    &:hover {
      background-color: #ffffff;
    }

    span {
      color: #272742;
      border: none;
    }
  }
`;

const Video = styled.div`
  grid-area: video;
  margin: 0 auto;
  align-self: baseline;
  Button {
    background-image: url(${play});
    height: 80px;
    width: 80px;
    border-radius: 50px;
    box-shadow: none;
    background-size: 108px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: transparent;
    &:hover {
      box-shadow: none;
      background-color: rgba(34, 34, 34, 0.25);
    }
    span {
      border-bottom: none;
    }
  }
`;

export { Container, Img, Wrapper, BannerText, Links, Video };
